import { useStore } from "vuex"
import FormInputTextField from "../FormInputTextField/FormInputTextField.vue"
import FormCheckbox from "../FormCheckbox/FormCheckbox.vue"
import { ref } from "vue"

export default {
    name: "CreateCancerForumProfile",
    components: {
        FormInputTextField,
        FormCheckbox
    },
    setup() {
        const store = useStore()
        const cancerForumName = ref("")
        const cancerForumConsent = ref(false)
        const displayError = ref({
            name: false,
            consent: false  
        })
        const isSubmitting = ref(false)

        const getLabel = (labelKey)=> store.getters['labels/getLabel']({labelCollection: "CreateCancerForumProfile", labelKey: labelKey})

        const cancerForumErrorLabel = ref(getLabel('formCancerForumNameErrorLabel'))

        const setConsent = (e) => {
            const checkbox = e.target
            cancerForumConsent.value = checkbox.checked ?? false
        }

        const submitCreateProfile = async () => {
            displayError.value.name = cancerForumName.value === ""
            displayError.value.consent = !cancerForumConsent.value

            if (cancerForumConsent.value && cancerForumName.value !== "") {

                isSubmitting.value = true

                const response = await store.dispatch('forum/createCancerForumProfile', { 
                    body: cancerForumName.value,
                    pageId: store.state.main.page_id                 
                })
                if (response.status === "error") {
                    displayError.value.name = true
                    cancerForumErrorLabel.value = response.message
                    isSubmitting.value = false
                }
            }
        }

        return {
            cancerForumName,
            cancerForumConsent,
            displayError,
            cancerForumErrorLabel,
            isSubmitting,
            setConsent,
            submitCreateProfile,
            getLabel,
        }
    }
}